import { render, staticRenderFns } from "./ProdesmeusiMaterials.vue?vue&type=template&id=1bf5d70d&scoped=true"
import script from "./ProdesmeusiMaterials.vue?vue&type=script&lang=js"
export * from "./ProdesmeusiMaterials.vue?vue&type=script&lang=js"
import style0 from "./ProdesmeusiMaterials.vue?vue&type=style&index=0&id=1bf5d70d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf5d70d",
  null
  
)

export default component.exports